/**
 * Chart
 */

// Import extend function.
import Component from '../../js/core/component.js';

class TableChart extends Component {
	/**
	 * Default settings for this component
	 * @return {object} Default settings
	 */
	_defaultSettings () {
		return {
			debug: false,
			chart: null,
			canvas: null,
			theChart: null,
			dataTable: null,
			json: [[]],
			headers: [],
			chartLabels: [],
			chartValues: [],
			yunit: null,
			xunit: null,
		};
	}

	/**
	 * Initialize component
	 */
	_init () {
		this.chart = this.settings.chart;
		this.canvas = this.chart.querySelector('canvas');
		this.dataTable = this.chart.querySelector('#datatable-' + this.canvas.id);
		this.headers = this._getHeaders(this.dataTable);
		this.json = this._getTableData(this.dataTable, this.headers);
		this.chartLabels = this.json.map(l => l.year);
		this.chartValues = this.json.map(v => v.amount);
		this.unit = this.canvas.dataset.yUnit;
		this.theChart = this._buildChart(
			this.chartLabels, 
			this.chartValues, 
			this.headers,
			this.canvas,
			this.unit
		);
	}

	_getHeaders(dataTable) {
		let headers = [];
		
		for (var i = 0; i < dataTable.rows[0].cells.length; i++) {
			headers[i] = dataTable.rows[0].cells[i].dataset.label.toLowerCase().replace(/ /gi, '');
		}
		
		return headers;
	}

	_getTableData (dataTable, headers) {

		let json = [];

		for (let i = 1; i < dataTable.rows.length; i++) {
			let tableRow = dataTable.rows[i];
			let rowData = {};
			for (var j = 0; j < tableRow.cells.length; j++) {
				rowData[headers[j]] = tableRow.cells[j].innerHTML;
			}

			json.push(rowData);
		}

		return json.reverse();
	}

	_buildChart (labels, values, chartTitle, canvas, unit) {
		let ctx = canvas.getContext('2d');
		/* eslint-disable */
		let chart = new Chart(ctx, {
		/* eslint-enable */
			type: 'line',
			data: {
				labels: labels,
				datasets: [{
					label: chartTitle,
					data: values,
					backgroundColor: 'rgba(40, 106, 141, 1)',
					borderColor: 'rgba(40, 106, 141, 1)',
					borderWidth: 2, 
					pointBackgroundColor: 'rgba(40, 106, 141, 1)',
					pointBorderColor: 'rgba(255, 255, 255, 1)',
					pointBorderWidth: 3,
					pointRadius: 4,
					fill: false,
				}],
			},
			options: {
				legend: {
					display: false
				},
				scales: {
					xAxes: [{
						gridLines: {
							display: false,
						}
					}],
					yAxes: [{
						ticks: {
							beginAtZero: true
						}
					}]
				},
				tooltips: {
					callbacks: {
						label: (item) => item.yLabel +  ' ' + unit
					}
				},
				responsive: true,
				maintainAspectRatio: false,
			}
		});

		return chart;
	}
}

document.addEventListener('newcontent', (e) => {
	e.target.querySelectorAll('.c-chart').forEach((element) => {
		element.chart = new TableChart({
			debug: true,
			chart: element
		});
	});
});

export default TableChart;


// WEBPACK FOOTER //
// ./components/chart/c-chart.js